import request from '@/utils/request'

// 所有专家
export function getList(data) {
	return request({
		url:'/app-api/biz/home/get-living-page',
		method: 'get',
		params: data
	})
}
